/**
 * PkZustellenDialog - confirm the e-mail Zustellung of the police to the customer (P2 Slice 15, Tab 6).
 */
import { Dialog } from '../administration/components';
import { Button } from '../../components/ui/Button';

const CODE_TEXT: Record<string, string> = {
  communication_send_required: 'Fuer den E-Mail-Versand fehlt die Berechtigung (communication.send).',
  nicht_abgeschlossen: 'Die Ausschreibung ist noch nicht abgeschlossen.',
  bereits_zugestellt: 'Die Police wurde bereits zugestellt.',
  kunde_email_fehlt: 'Fuer den Kunden ist keine E-Mail-Adresse hinterlegt.',
  dokument_fehlt: 'Zur Police ist kein Dokument hinterlegt.',
  dokument_geaendert: 'Das Dokument der Police wurde soeben geaendert - bitte erneut zustellen.',
  versand_laeuft: 'Ein Versand laeuft bereits.',
  versand_unterbrochen: 'Zustellung unterbrochen - bitte zuerst aufloesen.',
  record_failed: 'E-Mail gesendet, aber nicht erfasst. Bitte in der Zustellung aufloesen.',
  mailbox_not_connected: 'Ihr Postfach ist nicht verbunden.',
  mailbox_reauth_required: 'Ihr Postfach muss neu verbunden werden.',
  mailbox_send_failed: 'Der Versand ist fehlgeschlagen.',
};

export function PkZustellenDialog({
  open,
  onClose,
  onZustellen,
  kundeEmail,
  saving,
  error,
}: {
  open: boolean;
  onClose: () => void;
  onZustellen: () => void;
  kundeEmail: string | null;
  saving: boolean;
  error: { code?: string } | null;
}) {
  const errorText = error?.code ? CODE_TEXT[error.code] ?? 'Zustellung fehlgeschlagen' : null;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Police per E-Mail zustellen"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose}>Abbrechen</Button>
          <Button disabled={saving} onClick={onZustellen} data-testid="pk-zustellen-submit">
            Per E-Mail zustellen
          </Button>
        </div>
      }
    >
      <div className="space-y-2 text-sm" data-testid="pk-zustellen-dialog">
        <p>Police per E-Mail an {kundeEmail ?? 'den Kunden'} senden?</p>
        {errorText && <p className="text-sm text-status-danger" data-testid="pk-zustellen-error">{errorText}</p>}
      </div>
    </Dialog>
  );
}
